import { ReactNode } from 'react'
import styled from 'styled-components'
import './renewal.css'
import RenewalContactBand from './RenewalContactBand'
import RenewalFooter from './RenewalFooter'
import RenewalHeader from './RenewalHeader'
import RenewalTopStrip from './RenewalTopStrip'
import { RenewalCurrent } from './nav'
import { useRenewalMotion } from './useRenewalMotion'
import { useRenewalScrollRestore } from './useRenewalScrollRestore'

type RenewalLayoutProps = {
  children: ReactNode
  current?: RenewalCurrent
  industryKey?: string
  hideFooterBar?: boolean
  stripTone?: 'default' | 'snack'
  stripText?: string
  stripLinkText?: string
  stripHref?: string
  bandPage?: string
}

export default function RenewalLayout({
  children,
  current = 'home',
  industryKey,
  hideFooterBar = false,
  stripTone = 'default',
  stripText,
  stripLinkText,
  stripHref,
  bandPage,
}: RenewalLayoutProps) {
  useRenewalScrollRestore()
  useRenewalMotion()
  return (
    <div className="renewal-root">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Gabarito:wght@600;700;800&display=swap" />
      <style>{FONT_FACE}</style>
      <RenewalTopStrip tone={stripTone} text={stripText} linkText={stripLinkText} href={stripHref} />
      <Sticky>
        <RenewalHeader current={current} industryKey={industryKey} />
      </Sticky>
      {children}
      {hideFooterBar ? null : <RenewalContactBand page={bandPage ?? current} />}
      <RenewalFooter hideBar={hideFooterBar} />
    </div>
  )
}

const FONT_FACE = `
@font-face { font-family: 'Pretendard'; src: url('${process.env.PUBLIC_URL || ''}/renewal-assets/fonts/Pretendard-Regular.woff2') format('woff2'); font-weight: 400; font-display: swap; }
@font-face { font-family: 'Pretendard'; src: url('${process.env.PUBLIC_URL || ''}/renewal-assets/fonts/Pretendard-SemiBold.woff2') format('woff2'); font-weight: 600; font-display: swap; }
@font-face { font-family: 'Pretendard'; src: url('${process.env.PUBLIC_URL || ''}/renewal-assets/fonts/Pretendard-Bold.woff2') format('woff2'); font-weight: 700; font-display: swap; }
@font-face { font-family: 'Pretendard'; src: url('${process.env.PUBLIC_URL || ''}/renewal-assets/fonts/Pretendard-ExtraBold.woff2') format('woff2'); font-weight: 800; font-display: swap; }
`

const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 40;
  background: #ffffff;
`
